import React, { useEffect, useState } from 'react';

import GameAdvanced from './GameAdvanced';
import GameBasic from './GameBasic';
import { hasAnyPermissionForCompany } from '../auth/authUtils';
import permissionTypes from '../../constants/permissionTypes';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { usePageTitle } from '../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { getGameById } from '../../api/gameApi';

export interface GameProps {
  setCompleteRequestSlideoutOpen: (open: boolean) => void;
}

const ManageGame = ({ setCompleteRequestSlideoutOpen }: GameProps) => {
  const currentUser = useAppSelector((state) => state.auth);

  const { id } = useParams();
  const { t } = useTranslation();
  const [, setPageTitle] = usePageTitle(['Games']);
  const navigate = useNavigate();

  const [game, setGame] = useState<any>();
  const [reloadGame, setReloadGame] = useState<any>();

  useEffect(() => {
    if (id) {
      getGameById(id)
        .then((d: any) => {
          setGame(d);
          setPageTitle([d.name, 'Games']);
        })
        .catch((e: any) => {
          console.error(e);
          navigate('/games');
          toast.error(e.message || t('Game not found'));
        });
    }
  }, [id, navigate, reloadGame, setPageTitle, t]);

  return game ? (
    <>
      {hasAnyPermissionForCompany(
        currentUser,
        [
          permissionTypes.MANAGE_GAMES,
          permissionTypes.MANAGE_KEYS,
          permissionTypes.UNARCHIVE_GAMES,
        ],
        game.publisherCompanyId
      ) ? (
        <GameAdvanced
          key={id}
          setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
          game={game}
          setGame={setGame}
          reloadGame={reloadGame}
          setReloadGame={setReloadGame}
        />
      ) : (
        <GameBasic
          key={id}
          setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
          game={game}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default ManageGame;
